
import React from 'react';
import { Pencil, Trash2, Image } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TableRow, TableCell } from "@/components/ui/table";
import { Game } from "@/types/game";

interface GameTableRowProps {
  game: Game;
  onEdit: (game: Game) => void;
  onDelete: (id: string) => void;
}

export const GameTableRow: React.FC<GameTableRowProps> = ({ game, onEdit, onDelete }) => {
  return (
    <TableRow className="hover:bg-[#1E293B] border-[#222A35]">
      <TableCell className="text-white font-medium">{game.name}</TableCell>
      <TableCell>
        {game.cover_url ? (
          <div className="w-14 h-14 rounded-lg overflow-hidden border border-[#2A3749]">
            <img 
              src={game.cover_url} 
              alt={`Capa de ${game.name}`}
              className="w-full h-full object-cover"
              onError={(e) => {
                console.error("Error loading game image in admin:", game.name, game.cover_url);
                (e.target as HTMLImageElement).src = "https://placehold.co/100x100/252B36/AAAAAA?text=Sem+imagem";
              }}
            />
          </div>
        ) : (
          <div className="w-14 h-14 rounded-lg bg-[#252B36] flex items-center justify-center border border-[#2A3749]">
            <Image className="h-6 w-6 text-gray-500" />
          </div>
        )}
      </TableCell>
      <TableCell className="text-gray-400">
        {game.created_at 
          ? new Date(game.created_at).toLocaleDateString('pt-BR') 
          : 'N/A'}
      </TableCell>
      <TableCell className="text-right">
        <div className="flex justify-end gap-2">
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onEdit(game)}
            className="text-[#00B6F0] hover:text-blue-300 hover:bg-[#1E293B] border-[#2A3749]"
          >
            <Pencil className="h-4 w-4" />
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => onDelete(game.id)}
            className="text-red-500 hover:text-red-300 hover:bg-[#1E293B] border-[#2A3749]"
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};
